import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ModalWrapper, SectionTitle } from '../../shared/components';
import { AssignWorkView } from '../pages/AssignWorkPage';
import { WorkJobReportRow } from './workJobReport.api';

interface AssignWorkModalProps {
  /** The job the screen opens on; `null` keeps the dialog closed. */
  row: WorkJobReportRow | null;
  onClose: () => void;
  /** Called after work is assigned, so the caller can refresh what it shows. */
  onAssigned?: () => void;
}

/**
 * The Assign Work screen, over the report. It is the same component the `/work/assign`
 * route renders — not a copy — so the two cannot drift; the only difference is that the
 * job is preselected from the row that opened it.
 */
export default function AssignWorkModal({ row, onClose, onAssigned }: AssignWorkModalProps) {
  if (!row) return null;

  return (
    <ModalWrapper open onClose={onClose} maxWidth='lg'>
      <SectionTitle
        title={`ASSIGN WORK · ${row.job_code}`}
        meta={
          <Typography variant='body2' color='text.secondary'>
            {row.job_name}
          </Typography>
        }
      />

      <AssignWorkView initialJobId={row.id} hideTitle onAssigned={onAssigned} />

      <Stack direction='row' justifyContent='flex-end'>
        <Button onClick={onClose}>Close</Button>
      </Stack>
    </ModalWrapper>
  );
}
